<template>
  <div v-if="this.showCreate">
    <form @submit="onSubmit" @reset="onReset" class="mt-4">
      <b-card v-bind:header="this.$parent.form.titleAction" header-tag="header">
        <b-row>
          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Nombre</label>
              <b-form-input
                type="text"
                v-model="user.name"
                placeholder="Ingrese el nombre"
                maxlength="30"
                required
              />
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Apellido</label>
              <b-form-input
                type="text"
                v-model="user.lastName"
                placeholder="Ingrese el apellido"
                maxlength="30"
                required
              />
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Genero</label>
              <v-select
                :options="[{label: 'Femenino', code: 'F'}, {label: 'Masculino', code: 'M'}]"
                placeholder="Seleccione el genero"
                v-model="user.genre"
              ></v-select>
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Fecha Nacimiento</label>
              <datetime
                v-model="user.dateBorn"                
                auto
                type="date"
                input-class="form-control"
                placeholder="Seleccione la Fecha"
                input-id="dateBorn"
                required
              ></datetime>
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Tipo de Documento</label>
              <v-select
                label="description"
                :options="this.$parent.form.typeDocumentOptions"
                placeholder="Seleccione el tipo de documento"
                v-model="user.typeDocument"
                required
              ></v-select>
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Documento</label>
              <b-form-input
                type="number"
                v-model="user.documentNumber"
                placeholder="Ingrese el documento "
                required
              />
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>RH</label>
              <v-select
                label="description"
                :options="this.$parent.form.rhOptions"
                placeholder="Seleccione el RH"
                v-model="user.rh"
                required
              ></v-select>
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Telefono</label>
              <b-form-input
                type="number"
                v-model="user.telephone"
                placeholder="Ingrese el telefono"
                maxlength="10"
                required
              />
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Email</label>
              <b-form-input
                type="email"
                v-model="user.email"
                placeholder="Ingrese el correo"
                maxlength="40"
                autocomplete="false"
                required
              />
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Registro Médico</label>
              <b-form-input
                type="text"
                v-model="user.medicalRegister"
                placeholder="Ingrese el registro médico"
                maxlength="40"
                required
              />
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Especialidad</label>
              <v-select
                label="description"
                multiple
                :options="this.$parent.form.specialtyOptions"
                placeholder="Seleccione la especialidad"
                v-model="user.specialty"
                :required="!user.specialty"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Datos de Usuario -->
        <b-row class="mt-4">
          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Nombre de usuario</label>
              <b-form-input
                type="text"
                v-model="user.userName"
                placeholder="Ingrese el nombre de usuario"
                maxlength="20"
                required
                :readonly="!actionSave"
              />
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6">
            <b-form-group>
              <label>Roles</label>
              <v-select
                label="description"
                multiple
                :options="this.$parent.form.rolOptions"
                placeholder="Seleccione los roles"
                v-model="user.rol"
                required
              ></v-select>
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6" v-if="actionSave">
            <b-form-group>
              <label>Contraseña</label>
              <b-form-input
                type="password"
                id="password"
                name="password"
                v-model="user.password"
                placeholder="Ingrese la contraseña"
                minlength="6"
                maxlength="20"
                autocomplete="off"
                required
              />
            </b-form-group>
          </b-col>

          <b-col lg="3" sm="6" v-if="actionSave">
            <b-form-group>
              <label>Confirmar Contraseña</label>
              <b-form-input
                type="password"
                v-model="user.confirmPassword"
                placeholder="Confirme la contraseña"
                minlength="6"
                maxlength="20"
                ref="password"
                required
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-col class="pt-4">
          <b-button type="reset" size="sm" variant="secondary">Cancelar</b-button>
          <b-button type="submit" size="sm" variant="primary">{{this.$parent.form.buttonText}}</b-button>
        </b-col>
      </b-card>
    </form>
  </div>
</template>

<script>
import { log } from "util";
export default {
  data() {
    return {      
      items: [],
      showCreate: false,
      actionSave: true,
      user: {
        id: "",
        name: "",
        lastName: "",
        genre: null,
        dateBorn: "",
        typeDocument: null,
        documentNumber: "",
        telephone: "",
        rh: null,
        medicalRegister: "",
        specialty: null,
        signature: null,
        userName: "",
        email: "",
        rol: null,
        password: "",
        confirmPassword: ""
      }
    };
  },
  computed: {
    rows() {
      return this.items.length;
    }
  },
  methods: {
    onSubmit(evt) {
      const left = this;
      evt.preventDefault();

      if (this.user.genre == null) {
        this.showMessageToast("Seleccione el genero", null, null);
      } else if (this.user.rh == null) {
        this.showMessageToast("Seleccione el RH", null, null);
      } else if (this.user.specialty == null) {
        this.showMessageToast("Seleccione las especialidades", null, null);
      } else if (this.user.rol == null) {
        this.showMessageToast("Seleccione los roles", null, null);
      } else {
        var arraySpecialities = [];
        this.user.specialty.forEach(i => {
          arraySpecialities.push(i.id);
        });

        var arrayRoles = [];
        this.user.rol.forEach(i => {
          arrayRoles.push(i.id);
        });        

        if (this.actionSave) {
          if (this.user.password != this.user.confirmPassword) {
            this.showMessageToast("Contraseñas no son iguales", null, null);
          } else {
            this.axios
              .post(this.$apiURI_users + "/api/v1/users", {
                documen: this.user.documentNumber,
                first_name: this.user.name,
                last_name: this.user.lastName,
                gender: this.user.genre.code,
                birth_date: this.$moment(this.user.dateBorn).format(
                  "YYYY-MM-DD"
                ),
                phone_number: this.user.telephone,
                email: this.user.email,
                medical_record: this.user.medicalRegister,
                signature: this.user.signature,
                id_rh: this.user.rh.id,
                id_type_document: this.user.typeDocument.id,
                specialities: arraySpecialities,
                username: this.user.userName,
                password: this.user.password,
                role: arrayRoles
              })
              .then(function(response) {
                left.showMessageToast(
                  "Datos Guardados",
                  "Realizado con exito",
                  "success"
                );
                left.onReset();
                left.showCreate = false;
                left.$parent.showIndex = true;
                left.$parent.listUsers();
              });
          }
        } else {
          this.axios
            .put(this.$apiURI_users + "/api/v1/users", {
              id: this.user.id,
              documen: this.user.documentNumber,
              first_name: this.user.name,
              last_name: this.user.lastName,
              gender: this.user.genre,
              birth_date: this.$moment(this.user.dateBorn).format("YYYY-MM-DD"),
              phone_number: this.user.telephone,
              email: this.user.email,
              medical_record: this.user.medicalRegister,
              signature: this.user.signature,
              id_rh: this.user.rh.id,
              id_type_document: this.user.typeDocument.id,
              specialities: arraySpecialities,
              role: arrayRoles
            })
            .then(function(response) {
              left.showMessageToast(
                "Datos Actualizados",
                "Realizado con exito",
                "success"
              );
              left.onReset();
              left.showCreate = false;
              left.$parent.showIndex = true;
              left.$parent.listUsers();
            });
        }
      }
    },
    onReset() {
      var self = this;
      Object.keys(this.user).forEach(function(key) {
        if (
          key == "genre" ||
          key == "typeDocument" ||
          key == "specialty" ||
          key == "signature"
        ) {
          self.user[key] = null;
        } else {
          self.user[key] = "";
        }
      });
      this.showCreate = false;
      this.$parent.showIndex = true;
    },
    loadDataForm(i) {
      this.user.id = i.id;
      this.user.name = i.first_name;
      this.user.lastName = i.last_name;
      this.user.genre = i.gender;
      this.user.dateBorn = (i.birth_date).replace(/\s/g, '');
      this.user.typeDocument = i.type_document;
      this.user.documentNumber = i.documen;
      this.user.telephone = i.phone_number;
      this.user.rh = i.rh;
      this.user.medicalRegister = i.medical_record;
      this.user.specialty = i.specialtis;
      this.user.userName = i.username;
      this.user.email = i.email;
      this.user.rol = i.roles;
    },
    showMessageToast(message, title, color) {
      title = title != null ? title : "Campo requerido";
      color = color != null ? color : "info";
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 3000,
        variant: color
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/user/Create.vue